import { isOtherLanguage, languageName, needsEnglish } from '../utils/languageName';

/**
 * One turn of a call as the agent reads it. A turn spoken in another language
 * shows what was actually said (an agent checking a disputed detail needs the
 * original), labelled with its language, and the English rendering beneath —
 * so an agent who does not speak the caller's language can follow the call.
 */
export function TurnText({
  content,
  language,
  english,
}: {
  content: string;
  language?: string;
  english?: string;
}) {
  const hasEnglish = !!english && english.trim() !== '' && english !== content;
  // Another language when it has an English rendering, or when it was spoken
  // in one AND is written in another script. A Hindi caller saying "Hello",
  // a booking number or an email address needs no rendering and gets no label.
  const other = hasEnglish || (isOtherLanguage(language) && needsEnglish(content));

  return (
    <>
      {other && language && (
        <span className="co-mono mb-[3px] block text-[9.5px] font-semibold uppercase tracking-[.12em] text-[var(--co-ink-3)]">
          {languageName(language)}
        </span>
      )}
      <span>{content}</span>
      {other && (
        <span className="mt-[6px] block border-t border-[var(--co-line)] pt-[6px]">
          <span className="co-mono block text-[9.5px] font-semibold uppercase tracking-[.12em] text-[var(--co-brass-ink)]">
            In English
          </span>
          {hasEnglish ? (
            <span className="block">{english}</span>
          ) : (
            <span className="block italic text-[var(--co-ink-3)]">Translation not available yet</span>
          )}
        </span>
      )}
    </>
  );
}
